<template>
  <v-container>
    <v-tour name="vueTour" :steps="steps" :options="options" :callbacks="callbacks"></v-tour>
    <v-btn @click="startTour">{{ $t('tour.start') }}</v-btn>
  </v-container>
</template>

<script>
import { bus } from "../main";

export default {
  name: "vue-tour",
  data: () => ({
    steps: null,
    options: null,
    callbacks: {
      onStop: function() {
          bus.$emit('stopTour');
      }
    }
  }),
  created() {
    this.localizeTour();

    bus.$on("refreshCountry", () => {
      this.localizeTour();
    });
  },
  methods: {
    startTour() {
      bus.$emit('startTour');
      this.$tours["vueTour"].start();
    },
    localizeTour() {
      this.steps = [
        {
          target: "#country-changer",
          content: this.$t("tour.steps.country-changer.content")
        },
        {
          target: "#invoice",
          content: this.$t("tour.steps.invoice.content")
        },
        {
          target: "#desired-amount",
          content: this.$t("tour.steps.desired-amount.content")
        },
        {
          target: "#buttons",
          content: this.$t("tour.steps.buttons.content")
        }
      ];

      this.options = {
        useKeyboardNavigation: false,
        labels: {
          buttonSkip: this.$t("tour.skipTour"),
          buttonPrevious: this.$t("tour.previous"),
          buttonNext: this.$t("tour.next"),
          buttonStop: this.$t("tour.buttonStop")
        }
      };
    }
  }
};
</script>